import { useState } from 'react';
import { intervals } from '@constants';
import TransitionMenu from 'components/TransitionMenu';

export type IntervalDatePickerProps = {
  handleClick: (item: any) => void; // TODO- specify type
  // Optional
  intervalItems?: Array<Record<any, any>> | any;
  defaultSelectedItem?: Record<any, any>;
  isLoading?: boolean;
  accessorFn?: (item: any) => string;
};

const defaultAccessorFn = (item: any) => item.label;

const IntervalDatePicker = ({
  defaultSelectedItem,
  intervalItems,
  handleClick,
  isLoading = false,
  accessorFn = defaultAccessorFn,
}: IntervalDatePickerProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem || intervals[0].id);

  const handleMenuClick = (e: any) => {
    setAnchorEl(e.target);
    setOpen(true);
  };

  const handleMenuClose = () => {
    setOpen(false);
  };

  const handleMenuItemClick = (item: any) => {
    handleClick(item);
    setSelectedItem(item);
    handleMenuClose();
  };
  return (
    <TransitionMenu
      anchorEl={anchorEl}
      open={open}
      selectedItem={selectedItem}
      handleMenuClick={handleMenuClick}
      handleMenuClose={handleMenuClose}
      handleMenuItemClick={handleMenuItemClick}
      menuItems={intervalItems || intervals}
      isLoading={isLoading}
      accessorFn={accessorFn}
    />
  );
};

export default IntervalDatePicker;
